import condense from 'no-whitespace';

const imageName = (name) => {
  const jpegs = [
    'AdventHealthUniversity',
    'AuburnUniversity',
    'AveMariaUniversity',
    'AmericanLegion',
    'AmericaTheBeautiful',
    'AnimalFriend',
    'BarryUniversity',
    'BeaconCollege',
    'BestBuddies',
    'BigBrothersBigSisters',
    'BlueAngels',
    'BonefishTarponTrust',
    'CoastalConservationAssn',
    'ConserveWildlife',
    'DontTreadonMe',
    'DucksUnlimited',
    'EckerdCollege',
    'EdwardWatersUniversity',
    'EmbryRiddle',
    'EvergladesUniversity',
    'ExploreOffRoad',
    'ExploreOurStateParks',
    'FallenLawEnforcementOfficers',
    'FamilyValues',
    'FlaglerCollege',
    'FloridaAM',
    'FloridaArts',
    'FloridaAtlantic',
    'FloridaBayForever',
    'FloridaCollege',
    'FloridaGulfCoast',
    'FloridaInstituteofTechnology',
    'FloridaInternationalUniversity',
    'FloridaMemorial',
    'FloridaPanthers',
    'FloridaSheriffsAssociation',
    'FloridaSouthern',
    'FloridaStandsWithIsrael',
    'FloridaStateUniversity',
    'HodgesUniversity',
    'HomeOwnership',
    'IndianRiverLagoon',
    'InterMiamiCF',
    'JacksonvilleUniversity',
    'K9sUnited',
    'KeiserUniversity',
    'LighthouseAssociationVisitourLights',
    'LynnUniversity',
    'Margaritaville',
    'MiamiDolphins',
    'MiamiHeat',
    'MiamiMarlins',
    'MotorcycleBlueAngels',
    'Nascar',
    'NewCollege',
    'NovaSoutheasternUniversity',
    'OrlandoCity',
    'OrlandoMagic',
    'PalmBeachAtlanticUniversity',
    'ProtectBiscayneBay',
    'ProtectMarineWildlife',
    'ProtectOurOceans',
    'ProtectTheGopherTortoise',
    'ProtectthePanther',
    'RinglingSchool',
    'RollinsCollege',
    'SaintLeoUniversity',
    'SaintThomasUniversity',
    'SavetheBees',
    'SoutheasternUniversity',
    'StetsonUniversity',
    'StopChildAbuse',
    'SupportEducation',
    'SupportLawEnforcement',
    'SupportScenicWalton',
    'SwimForLife',
    'TampaBayBucs',
    'TampaBayLightning',
    'UniversityofAlabama',
    'UniversityofCentralFlorida',
    'UniversityofFlorida',
    'UniversityofNorthFlorida',
    'UniversityofGeorgia',
    'UniversityofTampa',
    'UniversityofWestFlorida',
    'WaltDisneyWorld',
    'WarnerUniversity',
    'WebberInternationalUniversity',
    'WildlifeFoundationofFlorida',
  ];
  let prefix = 'png';
  const clean = name.replace(/[^\w+]/igm, '');

  if (jpegs.indexOf(clean) > -1) {
    prefix = 'jpg';
  }

  return `${condense(clean)}.${prefix}`;
};

export default imageName;
